/* eslint-disable no-nested-ternary */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import MaxLengthNumericEditor from '../../../../SharedModules/CustomAgGridEditor/inputComponent';
import * as Styles from '../../../../SharedModules/StyleConstant/StyleConstant';
import { cellRenderer } from '../../../../SharedModules/utilities/utilities';

export const floatComparator = (valA, valB) => {
  return parseFloat(valA) - parseFloat(valB);
};

export function dateComparator(date1, date2) {
  const d1 = new Date(date1);
  const d2 = new Date(date2);

  if (isNaN(d1) && isNaN(d2)) return 0;
  if (isNaN(d1)) return -1;
  if (isNaN(d2)) return 1;

  return d1 - d2;
}

function amountComparator(amount1, amount2) {
  let amt1 = null;
  let amt2 = null;
  if (amount1 && amount1?.toString()?.includes('$')) {
    amt1 = parseFloat(
      amount1?.toString().split('$')[1]?.toString()?.replace(',', '').trim()
    );
  } else {
    amt1 = parseFloat(amount1?.toString()?.replace(',', '').trim());
  }
  if (amount2 && amount2?.toString()?.includes('$')) {
    amt2 = parseFloat(
      amount2?.toString().split('$')[1]?.toString()?.replace(',', '').trim()
    );
  } else {
    amt2 = parseFloat(amount2?.toString()?.replace(',', '').trim());
  }
  if (amt1 === null && amt2 === null) {
    return 0;
  }
  if (amt1 === null) {
    return -1;
  }
  if (amt2 === null) {
    return 1;
  }

  return amt1 - amt2;
}

export const selectClaimTableHead = [
  {
    headerName: 'Comments Exists',
    field: 'ccCommentsExist',
    filter: false,
    sortable: false,
    enableMenu: false,
    showCheckboxIcon: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: 120,

    resizable: true,
    editable: false,
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'ActionCellRender',
    cellStyle: () => {
      return { 'border-right-color': Styles.BorderColor };
    },
  },
  {
    headerName: 'Claim Invoiced',
    field: 'invoicedInd',
    editable: false,
    sortable: true,
    sortingOrder: ['desc', 'asc'],
    minWidth: Styles.Width_100,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    hideFilterIcon: true,
    showCheckboxIcon: true,
    cellRenderer: 'CustomCheckboxRenderer',
    cellStyle: () => {
      return { 'border-right-color': Styles.BorderColor };
    },
  },
  {
    headerName: 'Rebate Program Code',
    field: 'rebateProgramCd',
    wrapHeaderText: true,
    autoHeaderHeight: true,
    editable: false,
    sortable: true,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Service Date',
    field: 'serviceDt',
    wrapHeaderText: true,
    autoHeaderHeight: true,
    editable: false,
    sortable: true,
    minWidth: Styles.Width_120,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    comparator: dateComparator,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    cellRenderer: 'DateCellRenderer',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Paid Date',
    field: 'paidDt',
    wrapHeaderText: true,
    autoHeaderHeight: true,
    editable: false,
    sortable: true,
    minWidth: Styles.Width_120,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    comparator: dateComparator,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    cellRenderer: 'DateCellRenderer',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'MCO Paid Date',
    field: 'mcoPaidDt',
    wrapHeaderText: true,
    autoHeaderHeight: true,
    editable: false,
    sortable: true,
    minWidth: Styles.Width_120,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    cellRenderer: 'DateCellRenderer',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Original Units',
    field: 'origNumOfUnits',
    cellRenderer: 'ClaimOriginalUnitsRenderer',
    comparator: amountComparator,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    editable: false,
    sortable: true,
    minWidth: Styles.Width_120,
    printPrefixValue: '',
    exportZeroesFour: true,
    isTextColorRed: true,
    excelAlignment: 'right',
    cellClass: 'custom-align-right-cell',
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },

  {
    headerName: 'Number of Units',
    field: 'numOfUnits',
    cellRenderer: 'TextFieldComponentRenderer',
    exportZeroesFour: true,
    cellRendererSelector: (params) => {
      if (params && params.data && (params.data.adjustmentCd == 'V' || 
        params.data.adjustmentCd == 'Q')) {
        return { component: 'ClaimOriginalUnitsRenderer' };
      }
      return { component: 'TextFieldComponentRenderer' };
    },
    dataAlignRight: true,
    isTextColorRed: true,
    excelAlignment: 'right',
    minWidth: 150,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    maxLength: Styles.Length_255,
    sortingOrder: ['desc', 'asc'],
    cellStyle: {
      alignItems: 'right',
      'border-right-color': Styles.BorderColor,
    },
    comparator: amountComparator,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },

  {
    headerName: 'Billed Units',
    field: 'billedUnits',
    cellRenderer: 'TextFieldComponentRenderer',
     cellRendererSelector: (params) => {
      if (params && params.data && (params.data.adjustmentCd == 'V' || 
        params.data.adjustmentCd == 'Q')) {
        return { component: 'ClaimOriginalUnitsRenderer' };
      }
      return { component: 'TextFieldComponentRenderer' };
    },
    exportZeroesFour: true,
    dataAlignRight: true,
    isTextColorRed: true,
    excelAlignment: 'right',
    minWidth: 150,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    maxLength: Styles.Length_255,
    sortingOrder: ['desc', 'asc'],
    cellStyle: {
      textAlign: 'right',
      'border-right-color': Styles.BorderColor,
    },
    comparator: amountComparator,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'HCPCS Units',
    field: 'hcpcsUnits',
    cellRenderer: 'ClaimOriginalUnitsRenderer',
    minWidth: 130,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    maxLength: Styles.Length_255,
    comparator: amountComparator,
    printPrefixValue: '',
    exportZeroesFour: true,
    dataAlignRight: true,
    isTextColorRed: true,
    excelAlignment: 'right',
    sortingOrder: ['desc', 'asc'],
    cellStyle: {
      textAlign: 'right',
      'border-right-color': Styles.BorderColor,
    },
    cellClass: 'custom-align-right-cell',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Reimbursement Amt',
    field: 'reimbursementAmt',
    cellRenderer: 'PriceComponentCellRenderer',
    minWidth: 180,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    maxLength: Styles.Length_255,
    sortingOrder: ['desc', 'asc'],
    cellStyle: {
      alignItems: 'right',
      'border-right-color': Styles.BorderColor,
    },
    cellClass: 'custom-align-right-cell',
    dataAlignRight: true,
    isTextColorRed: true,
    excelAlignment: 'right',
    printPrefixValue: '$ ',
    comparator: amountComparator,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'TPL Amt',
    field: 'tplAmt',
    cellRenderer: 'PriceComponentCellRenderer',
    minWidth: 150,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    maxLength: Styles.Length_255,
    sortingOrder: ['desc', 'asc'],
    cellStyle: {
      alignItems: 'right',
      'border-right-color': Styles.BorderColor,
    },
    cellClass: 'custom-align-right-cell',
    dataAlignRight: true,
    isTextColorRed: true,
    excelAlignment: 'right',
    printPrefixValue: '$ ',
    comparator: amountComparator,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Co-pay Amt',
    field: 'copayAmt',
    cellRenderer: 'PriceComponentCellRenderer',
    minWidth: 150,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    maxLength: Styles.Length_255,
    sortingOrder: ['desc', 'asc'],
    cellStyle: {
      alignItems: 'right',
      'border-right-color': Styles.BorderColor,
    },
    cellClass: 'custom-align-right-cell',
    comparator: amountComparator,
    dataAlignRight: true,
    isTextColorRed: true,
    excelAlignment: 'right',
    printPrefixValue: '$ ',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Deductible Amt',
    field: 'deductibleAmt',
    cellRenderer: 'PriceComponentCellRenderer',
    minWidth: 150,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    maxLength: Styles.Length_255,
    sortingOrder: ['desc', 'asc'],
    cellStyle: {
      alignItems: 'right',
      'border-right-color': Styles.BorderColor,
    },
    cellClass: 'custom-align-right-cell',
    comparator: amountComparator,
    dataAlignRight: true,
    isTextColorRed: true,
    excelAlignment: 'right',
    printPrefixValue: '$ ',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },

  {
        headerName: 'Claim Reversed',
    field: 'reversingClaimLineNum',
    filter: false,
    minWidth: 120,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    showCheckboxIcon: true,
    maxLength: Styles.Length_255,
    sortingOrder: ['desc', 'asc'],
    sortable: true,
    cellStyle: {
      alignItems: 'left',
      'border-right-color': Styles.BorderColor,
    },
    cellRendererSelector: (params) => {
      if (params.node.rowPinned) {
        return { component: 'NoDataComponentRendererRenderer' };
      }
      return { component: 'CustomCheckboxRenderer' };
    },
  },
  {
    headerName: 'Provider ID Type',
    field: 'providerIdTypeVal',
    minWidth: 130,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    maxLength: Styles.Length_255,
    sortingOrder: ['desc', 'asc'],
    cellStyle: {
      alignItems: 'left',
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Provider ID',
    field: 'providerId',
    minWidth: 170,
    editable: false,
    sortable: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    suppressMenu: false,
    sortingOrder: ['desc', 'asc'],
    cellRenderer: 'ProviderIdCellRender',
    maxLength: Styles.Length_255,
    cellStyle: {
      alignItems: 'right',
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Category',
    field: 'computedCategoryCd',
    cellRenderer: 'CategoryCompCellRenderer',
    minWidth: 150,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    maxLength: Styles.Length_255,
    cellStyle: {
      'border-right-color': Styles.BorderColor,
    },
    cellClass: 'overrideDefault frr-ellipsis-text-overlap frr-ellipsis-text',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Procedure Code',
    field: 'procedureCd',
    minWidth: 150,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    maxLength: Styles.Length_255,
    sortingOrder: ['desc', 'asc'],
    cellStyle: {
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Med Unit Type',
    field: 'medUnitTypeCd',
    minWidth: 150,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    maxLength: Styles.Length_255,
    sortingOrder: ['desc', 'asc'],
    cellStyle: {
      alignItems: 'left',
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Claim ID',
    field: 'claimIdVO.claimId',
    minWidth: 180,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    maxLength: Styles.Length_255,
    columnSpan: 2,
    cellStyle: {
      alignItems: 'left',
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    cellRenderer: 'ClaimIdCellRender',
    sortingOrder: ['desc', 'asc'],
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Claim Line Number',
    field: 'claimIdVO.claimLineNum',
    minWidth: 160,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    maxLength: Styles.Length_255,
    cellStyle: {
      textAlign: 'right',
      'border-right-color': Styles.BorderColor,
    },
    excelAlignment: 'right',
    cellClass: 'custom-align-right-cell',
    filter: 'agTextColumnFilter',
    sortingOrder: ['desc', 'asc'],
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Prescription Number',
    field: 'prescriptionNum',
    minWidth: 180,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    maxLength: Styles.Length_255,
    cellStyle: {
      textAlign: 'right',
      'border-right-color': Styles.BorderColor,
    },
    excelAlignment: 'right',
    cellClass: 'custom-align-right-cell',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Client-Group-Plan',
    field: 'planId',
    minWidth: 230,
    maxLength: Styles.Length_255,
    cellStyle: {
      alignItems: 'left',
      'border-right-color': Styles.BorderColor,
    },
    cellRendererSelector: (params) => {
      if (params.node.rowPinned) {
        return { component: 'NoDataComponentRenderer' };
      }
      return undefined;
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Non Invoice Reason Cd',
    field: 'nonInvoiceReasonCd',
    minWidth: 180,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    maxLength: Styles.Length_255,
    cellStyle: {
      alignItems: 'left',
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Supp Invoiced',
    field: 'suppInvoicedInd',
    filter: false,
    minWidth: 120,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    showCheckboxIcon: true,
    maxLength: Styles.Length_255,
    sortable: true,
    sortingOrder: ['desc', 'asc'],
    cellStyle: {
      alignItems: 'left',
      'border-right-color': Styles.BorderColor,
    },
    cellRendererSelector: (params) => {
      if (params.node.rowPinned) {
        return { component: 'NoDataComponentRendererRenderer' };
      }
      return { component: 'CustomCheckboxRenderer' };
    },
  },
  {
    headerName: 'Supp Non Invoice Reason Cd',
    field: 'suppNonInvoiceReasonCd',
    minWidth: 200,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    maxLength: Styles.Length_255,
    cellStyle: {
      alignItems: 'left',
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'NDC Supplemental Exclusion IND',
    field: 'suppNdcExcInd ',
    filter: false,
    minWidth: 150,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    showCheckboxIcon: true,
    maxLength: Styles.Length_255,
    sortable: true,
    sortingOrder: ['desc', 'asc'],
    cellStyle: {
      alignItems: 'left',
      'border-right-color': Styles.BorderColor,
    },
    cellRendererSelector: (params) => {
      if (params.node.rowPinned) {
        return { component: 'NoDataComponentRenderer' };
      }
      return { component: 'CustomCheckboxRenderer' };
    },
  },
  {
    headerName: 'Drug Gross Amt',
    field: 'drugGrossAmt',
    minWidth: 150,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    maxLength: Styles.Length_255,
    sortingOrder: ['desc', 'asc'],
    cellStyle: {
      alignItems: 'right',
      'border-right-color': Styles.BorderColor,
    },
    cellClass: 'custom-align-right-cell',
    comparator: amountComparator,
    dataAlignRight: true,
    isTextColorRed: true,
    excelAlignment: 'right',
    cellRenderer: cellRenderer,
    printPrefixValue: '$',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },

  {
    headerName: 'Unlimited Flag',
    field: 'unlmtFlag',
    minWidth: 150,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    maxLength: Styles.Length_255,
    cellStyle: {
      alignItems: 'left',
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Supplied Days',
    field: 'suppliedDays',
    minWidth: 150,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    maxLength: Styles.Length_255,
    cellStyle: {
      textAlign: 'right',
      'border-right-color': Styles.BorderColor,
    },
    excelAlignment: 'right',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'NABP Number',
    field: 'nabpNum',
    minWidth: 150,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    maxLength: Styles.Length_255,
    cellStyle: {
      textAlign: 'right',
      'border-right-color': Styles.BorderColor,
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
